module.exports = __webpack_public_path__ + "img/Speaker=Jerry Lee.bb858676.png";